<template>
    <div class="gc-list-add-wrap">
        <van-nav-bar :border="false" 
            title="创建"
        />
        <div class="list-add-menu">
            <div tag="div" @click="handleAddHelp" class="item item1">
                <i></i>
                <div class="text">
                    <p class="p1">经营早报</p>
                    <p class="p2">融入团队、价值趋同、形成合力</p>
                </div>
            </div>
            <!-- <div class="item item2">
                <i></i>
                <div class="text"> 
                    <p class="p1">周ABC</p>
                    <p class="p2">任务规划管理、清晰、高效</p>
                </div>
            </div> -->
            <router-link tag="div" :to="{name:'AddProject',query:{type:0}}" class="item item3">
                <i></i>
                <div class="text">
                    <p class="p1">项目计划</p>
                    <p class="p2">融入团队、价值趋同、形成合力</p>
                </div>
            </router-link>
            <!-- <router-link tag="div" :to="{name:'AddProject',query:{type:1}}" class="item item4">
                <i></i>
                <div class="text">
                    <p class="p1">临时计划</p>
                    <p class="p2">融入团队、价值趋同、形成合力</p>
                </div>
            </router-link> -->
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isAdd: false,
                id: ''
            }
        },
        // beforeRouteEnter (to, from, next) {
        //     console.log(from);
        //     if (from.name == "AddHelp") {
        //         window.location.reload()
        //     }
        //     next();
        // },
        mounted() {
            this.WebGetManagementToolDetail();
        },
        methods: {
            handleAddHelp(){                
                if(this.isAdd){
                    this.$toast('今天您已经写过经营早报了')
                    return
                }
                let now = new Date();
                let nowTime = now.getTime();
                let year = now.getFullYear();
                let month = now.getMonth()+1;
                let day = now.getDate();
                let deadlineStr = year + "/" + month + "/" + day + " " + "10:00:00";
                let deadline = Date.parse(deadlineStr)
                // let deadline = new Date(deadlineStr).getTime()                
                if (nowTime <= deadline) {
                    this.$router.push({
                        name:'AddHelp',
                        params:{
                            id: this.id
                        }
                    })
                }else{
                    this.$toast('请在每天规定时间内写经营早报')
                }
            },
            // 当天是否已经添加过
            WebGetManagementToolDetail(){
                let data = {                   
                    UserSysno: localStorage.getItem('UserSysno')
                }
                this.$baseajax.normalJsonp(this.$base.baseapi+'/WebGetManagementToolDetail',data,res=>{
                    console.log(res); 
                    res = res.WebGetManagementToolDetailResult               
                    if(res.ResponseCode==1){
                        if(res.Item){                            
                            this.isAdd = true
                            this.id = res.Item.id
                        }
                    }else{
                        this.id = 0
                    }
                },err=>{})
            }
        },
    }
</script>

<style lang="less" scoped>
.gc-add-wrap{
    padding-bottom: 1.6rem;
}
.list-add-menu{
    padding-left: 0.28rem;
    padding-right: 0.28rem;
    .item{
        margin-top: 0.28rem;
        padding: .5rem 1.2rem;
        box-shadow: 0rem 1px 0.21rem 0rem 	rgba(32, 38, 148, 0.14);
        border-radius: 0.27rem;
        display: flex;
        align-items: center;
        i{
            width: 1.9rem;
            height: 1.9rem;
            margin-right: .8rem;
            background-size: contain;
            background-repeat: no-repeat;
        }
        .p1{
            font-size: 0.65rem;
            font-weight: 700;
            color: #ffffff;
        }
        .p2{
            margin-top: 0.1rem;
            font-size: 0.24rem;
	        color: #ffffff;
        }
        &.item1{
            background-image: linear-gradient(-80deg, #ee882d 0%, #f2c94c 100%);
            i{            
                background-image:url('~@/assets/add1.png');
            }
        }
        &.item2{
            background-image: linear-gradient(-80deg, #0d5cbe 0%, #4f9cea 100%);
            i{            
                background-image:url('~@/assets/add2.png');
            }
        }
        &.item3{
            background-image: linear-gradient(-80deg, #00ad55 0%, #67e891 100%);
            i{            
                background-image:url('~@/assets/add3.png');
            }
        }
        &.item4{
            background-image: linear-gradient(-80deg, #d44536 0%, #ff9369 100%);
            i{            
                background-image:url('~@/assets/add4.png');
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/add/Add.vue